import {http} from "../utils/http";
import {Response} from '../types/resp';
export const promotion = {
	getPromotionList: async (payload: any) => {
		return http.post<Response<any>>('/promotion/getPromotionListPost', payload)
	},

	getMissionBonus: async (payload: any) => {
		return http.get<Response<any>>('/promotion/getMissionBonus')
	},

	getAllPromotion: async () => {
		return http.get<Response<any>>('/promotion/getAllPromotion')
	},

	getVipByCustomer: async (payload: any) => {
		return http.get<Response<any>>('/promotion/getVipByCustomer')
	},

	findPromotionByPlayer: async (payload: any) => {
		return http.post<Response<any>>('/promotion/findPromotionByPlayerPost', payload)
	},

	receiveVipByCustomer: async (payload: any) => {
		return http.post<Response<any>>('/promotion/receiveVipByCustomer', payload)
	},

	checkPromotionByPromotionID: async (payload: any) => {
		return http.post<Response<any>>('/promotion/checkPromotionByPromotionID', payload)
	},

	createAutoPromotionCustomers: async (payload: any) => {
		return http.post<Response<any>>('/promotion/createAutoPromotionCustomers', payload)
	},

	updateAutoPromotionCustomers: async (payload: any) => {
		return http.post<Response<any>>('/promotion/updateAutoPromotionCustomers', payload)
	},

	getAutoPromotionCustomers: async (payload: any) => {
		return http.post<Response<any>>('/promotion/getAutoPromotionCustomers', payload)
	},

	getListPromotionByType: async (payload: any) => {
		return http.post<Response<any>>('/promotion/getListPromotionByType', payload)
	},

	getMissionList: async (payload: any) => {
		return http.post<Response<any>>('/promotion/getMissionList', payload)
	},
}
